import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Usuario from 'Interface/Usuarios';
import { useEditarUsuarioMutation } from 'Service';

interface Props {
  dados: Usuario;
  acoes?: boolean;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [editarUsuario] = useEditarUsuarioMutation();

  const remover = async (): Promise<void> => {
    try {
      await editarUsuario({ id: dados.id, ativo: false }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3 gap-3">
      <Link to={`/admin/usuarios/editar/${dados.id}`}>
        <Imagem
          src={dados.imagem}
          alt={dados.nome}
          className="rounded-circle object-fit-cover"
          width="80"
          height="80"
        />
      </Link>
      <div className="fs-5 text-truncate">
        <Link
          to={`/admin/usuarios/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.nome}
        </Link>
        <small className="d-block fs-6 text-muted text-truncate">
          <Icone nome="envelope" className="me-2" />
          {dados.email}
        </small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end gap-5">
        <div className="fs-6 text-end text-nowrap">
          {dados.cpf}
          <small className="d-block fs-6 text-muted">
            <Icone nome="file-person" className="me-2" />
            CPF
          </small>
        </div>
        <div className="fs-6 text-end text-nowrap">
          {dados.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
          <small className="d-block fs-6 text-muted">
            <Icone nome="calendar" className="me-2" />
            Criado em
          </small>
        </div>
        <div className="fs-5 text-end d-flex gap-2 align-items-center">
          {dados.assinatura ? (
            <>
              {dados.assinatura.status ? (
                <Icone nome="check-circle" className="text-success" />
              ) : (
                <Icone nome="x-circle" className="text-danger" />
              )}
            </>
          ) : (
            <Icone nome="dash-circle" className="text-warning" />
          )}
          {dados.esf && <span className="badge bg-success">ESF</span>}
          <span className="badge bg-primary">{dados.permissao}</span>
          <a
            href={`https://api.whatsapp.com/send?phone=55${dados?.telefone1
              .replace('(', '')
              .replace(')', '')
              .replace('-', '')
              .replace(' ', '')}`}
            className="btn btn-success"
            target="_blank"
            rel="noreferrer"
          >
            <Icone nome="whatsapp" />
          </a>
          <Botao
            icone="trash"
            tema="danger"
            confirmacao="Você tem certeza que deseja remover esse usuário? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
